// apps/landing-page/src/lib/constants.ts

/**
 * Cross-category payment method display order used by CartDrawer.tsx's
 * `sortedCategories`. QRIS and e-wallets carry lower (often zero)
 * buyer-facing fees than bank transfer (VA) methods, so they're surfaced
 * first ahead of VAs — a deliberate conversion decision, not alphabetical
 * order or a mirror of DB sortOrder. Within a single category, DB
 * sortOrder asc still applies (see CartDrawer's groupedMethods / the
 * payment-methods fetch, which is already ordered by the API).
 *
 * Twin of apps/dashboard/src/lib/constants.ts's PAYMENT_CATEGORY_ORDER —
 * the two checkouts must not disagree about method ordering. Keep in sync.
 */
export const PAYMENT_CATEGORY_ORDER = ['QRIS', 'E_WALLET', 'BANK_TRANSFER', 'RETAIL_OUTLET', 'CREDIT_CARD'] as const;

/**
 * Below this post-discount subtotal, CartDrawer collapses BANK_TRANSFER
 * (VA) payment methods behind a "Metode lain" toggle instead of listing
 * them by default. A flat VA fee (Rp4,000+) is a much bigger fraction of a
 * small order than a large one, so the near-zero-fee methods (QRIS,
 * e-wallet) are what a small order sees first. A pre-selected VA method is
 * never collapsed — see CartDrawer's `selectedIsInCollapsedCategory`.
 *
 * Twin of apps/dashboard/src/lib/constants.ts's SMALL_ORDER_VA_COLLAPSE_THRESHOLD.
 * Keep the two values in sync.
 */
export const SMALL_ORDER_VA_COLLAPSE_THRESHOLD = 50_000;
